/* eslint-disable indent */
import React, { useEffect, useState } from 'react';
import TrucksMapDialogStyles from './TrucksMapDialog.component.styles';
import { compose } from 'recompose';
import { bindActionCreators } from 'redux';
import cn from 'classnames';
import { Typography, Slide, Dialog, AppBar, Snackbar, Toolbar, Grid, IconButton } from '@material-ui/core';
import { withGlobalStyles } from 'Support/Theme/CreateInjectableStyles/withGlobalStyles';
import CloseIcon from '@material-ui/icons/Close';
import withServices from '../../Contexts/Services/WithServices.context';
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorIcon from '@material-ui/icons/Error';
import { empty } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { connect } from 'react-redux';
import uiActionCreators from '../../State/Store/UI/UI.actions';
import TrucksMap from '../TrucksMap/TrucksMap.component';
import { MFSDR } from 'Constants/MouseFlow/SensitiveDataReplacer';

const TrucksMapDialog = ({ classes, open, onClose, services, currentOrder }) => {
  const secondsToRefresh = 10;

  const [counter, setCounter] = useState(10);
  const [errorVisible, setErrorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [trucksLoading, setTrucksLoading] = useState(false);

  const [currentTrucks, setCurrentTrucks] = useState();

  const isInvalidTruck = (truck) => !truck.lat || !truck.lng || truck.eta === 'N/A';

  const getInvalidTrucks = (trucks) => {
    return trucks.filter((truck) => {
      if (isInvalidTruck(truck)) {
        return true;
      }
      return false;
    });
  };

  const requestTrucksForMap = () => {
    if (counter >= secondsToRefresh) {
      setCounter(0);

      // refresh trucks from api here
      setTrucksLoading(true);

      (async () => {
        try {
          const { summary } = currentOrder || {};
          if (!summary) {
            return;
          }
          const { startTime, orderCode, orderLine } = summary;

          const loadedTrucks = await services.orderService.getTrucksForMap({
            orderCode,
          });

          loadedTrucks
            .pipe(
              retry(1),
              catchError((err) => {
                setErrorVisible(true);
                setTrucksLoading(false);
                return empty();
              }),
            )
            .subscribe((result) => {
              const invalidTrucks = getInvalidTrucks(result.trucks);
              if (invalidTrucks.length) {
                const invalidTrucksMessage = invalidTrucks.reduce((acc, el, i) => {
                  if (invalidTrucks.length === 1) {
                    return el.truckNumber;
                  } else if (invalidTrucks.length - 2 === i) {
                    // second last element so add "and"
                    acc = acc + el.truckNumber + ' and ';
                  } else if (invalidTrucks.length - 1 === i) {
                    // second last element so add "and"
                    acc += el.truckNumber;
                  } else {
                    acc = acc + el.truckNumber + ', ';
                  }
                  return acc;
                }, '');
                setErrorVisible(true);
                setErrorMessage(`Truck ${invalidTrucksMessage} cannot be displayed on the map at this time`);
              } else {
                setErrorVisible(false);
              }
              const validResult = {
                ...result,
                _invalidTrucks: invalidTrucks.length,
                trucks: result.trucks.filter((truck) => !isInvalidTruck(truck)),
              };
              setCurrentTrucks(validResult);
            });
        } catch (ex) {
          setErrorVisible(true);
          setErrorMessage(`Something went wrong loading trucks for map`);
        }

        console.log('trucks finished loading');
        setTrucksLoading(false);
      })();
    } else {
      setCounter(counter + 1);
    }
  };

  useEffect(() => {
    // make initial request
    requestTrucksForMap();
  }, []);

  useEffect(() => {
    if (!open) {
      setCounter(0);
      setErrorVisible(false);
      return;
    }

    const timeout = setTimeout(requestTrucksForMap, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [open, counter]);

  return (
    <Dialog className={classes.dialogWrapper} open={open} onClose={onClose} TransitionComponent={Transition} fullScreen>
      <Snackbar
        action={[
          <IconButton aria-label="Close" className={classes.close} color="inherit" key="close" onClick={() => setErrorVisible(false)}>
            <CloseIcon />
          </IconButton>,
        ]}
        anchorOrigin={{
          horizontal: `left`,
          vertical: `bottom`,
        }}
        className={classes.snackbar}
        ContentProps={{ classes: { root: classes.error } }}
        message={
          <span className={classes.snackbarMessage} id="client-snackbar" data-mf-replace-inner={MFSDR}>
            <ErrorIcon className={classes.snackbarIcon} />
            {errorMessage}
          </span>
        }
        open={errorVisible}
      />
      <AppBar classes={{ root: classes.appBar }}>
        <Toolbar>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <IconButton color="inherit" onClick={onClose} aria-label="Close">
                <CloseIcon />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography variant="h6" color="inherit">
                Trucks Map
              </Typography>
            </Grid>
            <Grid item className={cn(classes.flexGrow1, classes.textAlignRight)}>
              <CircularProgress size={32} className={cn(classes.circularProgress)} value={Math.floor((counter / secondsToRefresh) * 100)} variant="static" />
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <TrucksMap trucksInfo={currentTrucks} />
    </Dialog>
  );
};

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

export default compose(withGlobalStyles(TrucksMapDialogStyles), withServices,
connect(
  null,
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...uiActionCreators,
      },
      dispatch,
    ),
  }),
))(TrucksMapDialog);
